import { OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import {
  WorkflowGraphDispatcherAction,
  WorkflowGraphDispatcherService
} from './workflow-graph-dispatcher.service';

export abstract class AbstractWorkflowGraphDispatcherObserver implements OnInit, OnDestroy {

  dispatcher$: Subscription;

  constructor(protected dispatcherService: WorkflowGraphDispatcherService) {

  }

  abstract onDispatcherEvent(action: WorkflowGraphDispatcherAction);

  ngOnDestroy() {
    if (this.dispatcher$) {
      this.dispatcher$.unsubscribe();
      this.dispatcher$ = null;
    }
  }

  ngOnInit() {
    this.dispatcher$ = this.dispatcherService.subscribe(action => this.onDispatcherEvent(action));
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/abstract-workflow-graph-dispatcher-observer.ts